const isBrowser = typeof window !== 'undefined';

/**
 * Determine if WebGL is supported by the user agent.
 */
function isWebGlSupported() {
  // WebGL is not supported on the server side render
  if (!isBrowser) {
    return false;
  }

  const c = document.createElement('canvas');

  try {
    return !!window.WebGLRenderingContext
      && c.getContext('experimental-webgl', { premultipliedAlpha: false }); // GLFX only uses 'experimental-webgl' so we can simplify the check
      // && (!!c.getContext('experimental-webgl') || !!c.getContext('webgl'));
  } catch (e) {
    return false;
  }
}

/**
 * Determine which features are enabled by the query string
 *
 * @return {object}
 */
function getQueryStringFeatureFlags() {

  // Nothing is enabled for the server side render
  if (!isBrowser) {
    return {};
  }

  // Convert the query string to an array of <key>=<value> strings
  const query = location.search.slice(1).split('&');

  // Extract the keys from the query as that's all we need for feature flags
  const features = query.map(pair => pair.split('=')[0]);

  // Convert the array of feature names into an object
  return features.reduce((memo, feature) => ({
    ...memo,
    [feature]: true
  }), {});
}

// Export an object of feature flags
export const FEATURE_FLAGS = {
  userAgent: {
    webgl: isWebGlSupported()
  },
  // Add a crude query string feature flag for filters so we can expirement with it
  // while the server doesn't work.
  queryString: getQueryStringFeatureFlags,
  adjustments: {
    crop: true,
    flip: true,
    rotate: true,
    filters: false, // flags => flags.userAgent.webgl && flags.queryString.filters,
    adjust: false, // flags => flags.userAgent.webgl && flags.queryString.filters
  }
};



// WEBPACK FOOTER //
// ./src/constants/features.js